import React, { FC } from 'react';
import { AuditLog } from '@/types';
import { DamageLineDetails } from './DamageLineDetails';

interface EntityDetailsProps {
  data: AuditLog;
  inspectionId: number;
}

export const EntityDetails: FC<EntityDetailsProps> = ({
  data,
  inspectionId,
}) => {
  switch (data.originalEventType) {
    case 'ReturnInspectionDamageDetail':
      return <DamageLineDetails data={data} inspectionId={inspectionId} />;
    default:
      return null;
  }
};
